export default "__VITE_ASSET__CXrTeuXp__"